export default __webpack_public_path__ + "static/media/bee2.80ee7aa4.png";